<template>
  <SPSliderSection
    class="news-and-events-section"
    :title="title"
    :data="news"
    :class="ui?.root"
    :loading="loading"
    :all-button="allButton"
    mobile-all-button
    :ui="{
      header: ui?.header,
      title: ui?.title,
    }"
  >
    <template #default="{ slide }">
      <CommonCard
        :item="slide"
        :to="`/news/${slide.id}`"
        image-top-left="lesson-types"
        image-top-right="rating"
        title-above-left="school"
        :description="slide.preview_description"
        description-under-left="date"
        description-under-right="directions"
        :ui="{
          title: 'line-clamp-2! mb-3',
          body: 'flex flex-col justify-between',
        }"
      />
    </template>
  </SPSliderSection>
</template>

<script lang="ts" setup>
import type { News } from '~/api/index.js'

defineOptions({
  name: 'NewsAndEventsSection',
})

const props = withDefaults(
  defineProps<{
    news?: News[]
    title?: string
    loading?: boolean
    allButton?: {
      label: string
      to: string
    }
    ui?: {
      root?: string
      header?: string
      title?: string
      card?: string
      cardTitle?: string
      description?: string
      badge?: string
      direction?: string
      imageWrapper?: string
      image?: string
    }
  }>(),
  {
    title: 'Новости и события',
    allButton: () => ({
      label: 'Все новости',
      to: '/news',
    }),
  },
)

const pageStore = usePageStore()
const { mainPage } = storeToRefs(pageStore)

const news = computed(() => props.news || mainPage.value?.news || [])
</script>

<style lang="scss" scoped>
:deep(.common-card) {
  --card-height: 488px;
  --card-image-height: 240px;

  @include max-xl {
    --card-height: 412px;
    --card-image-height: 200px;
  }

  @include max-md {
    --card-height: 345px;
    --card-image-height: 150px;
  }

  &:hover {
    .image {
      transform: scale(1.15);
    }
  }

  .image-wrapper {
    overflow: hidden;
  }

  :deep(.body-header) {
    @include max-md {
      display: none;
    }
  }
}
</style>
